import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, alpha } from '@mui/material';
import { useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Dashboard from './pages/Dashboard';
import UsersPage from './pages/UsersPage';
import RetailsPage from './pages/RetailsPage';
import CategoriesPage from './pages/CategoriesPage';
import ProductsPage from './pages/ProductsPage';
import WidgetsPage from './pages/WidgetsPage';
import WidgetWizard from './pages/WidgetWizard';
import WidgetEditor from './pages/WidgetEditor';
import SpecsImport from './pages/SpecsImport';
import ConfigPage from './pages/ConfigPage';

const LoadingScreen = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}
  >
    <Box
      sx={{
        p: 4,
        borderRadius: 3,
        backgroundColor: alpha('#ffffff', 0.95),
        backdropFilter: 'blur(20px)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <CircularProgress size={48} thickness={4} />
      <Typography variant="body2" color="text.secondary">
        Cargando aplicación...
      </Typography>
    </Box>
  </Box>
);

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="retails" element={<RetailsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="widgets" element={<WidgetsPage />} />
        <Route path="widgets/new" element={<WidgetWizard />} />
        <Route path="widgets/:id/edit" element={<WidgetWizard />} />
        <Route path="widgets/:id/editor" element={<WidgetEditor />} />
        <Route path="specs/import" element={<SpecsImport />} />
        <Route path="config" element={<ConfigPage />} />
      </Route>
    </Routes>
  );
}

export default App;
